import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../contexts/ThemeContext';

const Settings = () => {
    const { t, i18n } = useTranslation();
    const isRTL = ['ar', 'ku'].includes(i18n.language);

    return (
        <div className="max-w-7xl mx-auto" dir={isRTL ? 'rtl' : 'ltr'}>
            <div className="mb-8">
                <h1 className="text-2xl font-bold text-zinc-900">{t('settings')}</h1>
                <p className="text-zinc-500">{t('manage_your_account_and_system_preferences')}</p>
            </div>

            <div className="pt-2">
                <Outlet />
            </div>
        </div>
    );
};

export default Settings;
